import { PaperClipOutlined } from '@ant-design/icons';

import { ActionButton } from '@hdi-seguros/web-components.action-button';

interface FileViewerButtonProps {
  base: string;
  name: string;
}

export const FileViewerButton = ({ name, base }: FileViewerButtonProps) => {
  const openFile = (file: string) => {
    const newWindow = window.open();

    if (newWindow) {
      const document: string = `<iframe src="${file}" style="width:100%; height:100%;"></iframe>`;
      newWindow.document.write(document);
    }
  };

  return (
    <ActionButton
      label={name}
      icon={<PaperClipOutlined />}
      color='secondaryDefault'
      type='text'
      onClick={() => openFile(base)}
    />
  );
};
